module.exports = {
  AdminTrxRouting: require('./components/TrxRouting'),
  TrxTableDisplay: require('./components/TrxTableDisplay'),
  TrxTableItemDisplay: require('./components/TrxTableItemDisplay'),
  TrxDataDisplay: require('./components/TrxDataDisplay'),
  PaymentsTableDisplay: require('./components/PaymentsTableDisplay'),
  PaymentsTableItemDisplay: require('./components/PaymentsTableItemDisplay'),
  ReconTableDisplay: require('./components/ReconTableDisplay'),
  ReconTableItemDisplay: require('./components/ReconTableItemDisplay'),
}
